import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA, effect,
  ElementRef,
  inject,
  NgZone,
  viewChild
} from '@angular/core';
import {MapComponent} from './components/map/map.component';
import '@geodan/gm-modal/build/dist/gm-modal';
import {GameStore} from './store/game.store';
import {ResourcesService} from './services/resources.service';
import {StartingScreenComponent} from './screens/starting-screen/starting-screen.component';
import {PlayingScreenComponent} from './screens/playing-screen/playing-screen.component';
import {GameOverScreenComponent} from './screens/game-over-screen/game-over-screen.component';

@Component({
    selector: 'gis-root',
    imports: [MapComponent, StartingScreenComponent, PlayingScreenComponent, GameOverScreenComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  protected readonly resourcesService = inject(ResourcesService);
  protected readonly store = inject(GameStore);
  private readonly ngZone = inject(NgZone);

  readonly gmModal = viewChild<ElementRef>('gmModal');
  readonly mapContainer = viewChild<ElementRef<HTMLElement>>('mapContainer');
  readonly mapComponent = viewChild<MapComponent>('mapComponent');

  resizeObserver?: ResizeObserver;
  bodyElement = document.querySelector('body') as HTMLElement;
  mapMaxWidth = 653;
  mapMaxHeight = 791;
  cssMediaQueryBreak = 800;
  mapFlexBasis = '0';

  constructor() {
    effect(() => {
      if(this.store.error()) {
        this.onError();
      }
    });
  }

  ngAfterViewInit() {
    this.setResizeObserver();
  }

  onError() {
    this.gmModal()?.nativeElement.show();
  }

  setResizeObserver() {
    this.resizeObserver = new ResizeObserver(entries => this.setMapContainerHeight(entries));
    this.resizeObserver.observe(this.mapContainer()?.nativeElement as HTMLElement);
  }

  setMapContainerHeight(entries: ResizeObserverEntry[]) {
    // contentRect might be deprecated in the future, but has for now better browser support than borderBoxSize, see:
    // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentRect
    const bodyWidth = this.bodyElement.clientWidth;
    const mapContainerWidth = entries[0].contentRect.width;

    this.ngZone.run(() => {
      // Above 800 flexBasis defines the width, for 800 and below flexbasis defines the height; see the css @media query in which flex direction is set to column
      this.mapFlexBasis = bodyWidth > this.cssMediaQueryBreak ? `${this.mapMaxWidth}px` : `${(this.mapMaxHeight / this.mapMaxWidth) * mapContainerWidth}px`;
    });

    if (this.mapComponent()?.map) {
      this.mapComponent()!.setMapView();
    }
  }
}
